export default __webpack_public_path__ + "static/media/ppt6_intro.70f1b3ac.png";